<template>
  <div class="card">
    <Cell
      v-if="false"
      is-link
      value="更多"
      :border="false"
      @click="$router.push('trend')"
      style="padding-bottom: 0"
    >
      <template #title><p class="card-title">行情走势</p></template>
    </Cell>

    <Tabs @change="onSwitch" class="vc-tabs">
      <template v-for="{ id, name, list, loading, total } of tabs">
        <Tab
          :key="id + name"
          :name="id"
          :title="name + '每日行情'"
          class="vc-tab"
        >
          <div class="vc-table">
            <template v-if="!!list.length">
              <div class="-row -header">
                <div class="-span">{{ name }}</div>
                <div
                  v-for="({ date }, n) of list[0].prices"
                  :key="'price-span-' + n"
                  class="-span"
                >
                  {{ date.split("-").pop() }} 日价格
                </div>
                <div class="-span">涨跌</div>
              </div>

              <div
                v-for="({ name, code, prices }, n) of list"
                :key="code"
                @click="
                  $router.push({
                    name: 'trendDetail',
                    params: { ...data[n] },
                  })
                "
                class="-row"
              >
                <div class="-span">{{ name }}</div>
                <div
                  v-for="({ price }, n) of prices"
                  :key="'price-span-' + n"
                  class="-span"
                >
                  {{ price }}
                </div>
                <div
                  :class="[
                    '-span',
                    '-price',
                    upDownEcho(prices, '_up', '_down'),
                  ]"
                >
                  {{ upDownEcho(prices, "+", "") }}{{ upDown(...prices) }}
                  <a>&#8594;</a>
                </div>
              </div>
            </template>

            <template v-else>
              <span>暂无数据更新～</span>
            </template>

            <Loading
              v-show="loading"
              style="
                display: flex;
                justify-content: center;
                margin-top: 12px;
                margin-bottom: -6px;
              "
            />

            <button
              v-show="
                total > maxShowNum &&
                list.length < total &&
                maxShowNum !== undefined
              "
              @click="showMore(id)"
              type="button"
              class="-more"
            >
              展开
            </button>
          </div>
        </Tab>
      </template>
    </Tabs>
  </div>
</template>

<script>
import { Cell, Tab, Tabs, Loading } from "vant";

import { postRequest } from "@/api/server";

export default {
  name: "PriceMarketTable",
  data() {
    return {
      maxShowNum: 8,
      tabs: [],
    };
  },
  props: {
    data: Array,
  },
  async created() {
    await this.fetchTypes();

    // await this.fetchList(this.tabs[0]?.id);
    for (const { id } of this.tabs) {
      await this.fetchList(id);
    }
  },
  methods: {
    async fetchTypes() {
      try {
        const types = await postRequest("/market/marketType");

        this.tabs = types.map(({ id, typeName: name }) => ({
          loading: null,
          id,
          name,
          list: [],
        }));
      } catch (error) {}
    },
    async fetchList(id = null, showAll = false) {
      if (id !== 0 && !id) return;

      const target = this.tabs.find(({ id: _id }) => id === _id);
      target.loading = true;

      try {
        const [page, size, typeId] = [1, showAll ? 999 : this.maxShowNum, id];
        const { list, total } = await postRequest("/market/marketTypePages", {
          page,
          size,
          typeId,
        });
        const sliceList = list?.slice(0, this.maxShowNum);
        const convertList = (showAll ? list : sliceList)?.map(
          ({
            marketInfo: { id, description, marketCode: code, marketName: name },
            todayDate,
            todayPrice,
            yesDate,
            yesPrice,
            upDown,
            changePrice: diff,
          }) => ({
            id,
            description,
            code,
            name,
            upDown,
            diff,
            prices: [
              { date: todayDate, price: todayPrice },
              { date: yesDate, price: yesPrice },
            ],
          })
        );

        target.total = total;
        target.list = convertList;
      } catch (error) {
        console.log(error);
      } finally {
        target.loading = null;
      }
    },
    upDown({ price: latest }, { price: previous }) {
      return parseInt(latest - previous, 10);
    },
    upDownEcho(prices, up, down) {
      const ret = this.upDown(...prices);

      if (ret > 0) return up;
      if (ret < 0) return down;

      return "";
    },
    showMore(id) {
      this.fetchList(id, true);
    },
    onSwitch(id) {
      console.log(id);
      //   this.fetchList(id);
    },
  },
  components: {
    Cell,
    Tabs,
    Tab,
    Loading,
  },
};
</script>

<style lang="less" scoped>
.vc-tab-nav {
  background-color: white;
  height: 32px;
  border-bottom: 1px solid lightgray;
}

.vc-tabs {
  background-color: white;
  padding-bottom: 12px;

  /deep/ .van-tabs__line {
    border-radius: 0;
    width: 24px;
  }

  /deep/ .van-tab {
    justify-content: left;
    flex: unset;
    padding: 0 8px;
  }
}

.vc-tab {
  border-top: 1px solid #e5e5e5;
  padding: 8px;
}

.vc-table {
  font-size: 12px;

  .-row {
    line-height: 2.35;
    border-left: 1px solid #e5e5e5;
    justify-content: center;
    align-items: center;
    direction: row;
    display: flex;

    .-span {
      width: 25%;
      padding: 0 4px;
      white-space: nowrap;
      overflow: auto;
      text-overflow: ellipsis;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-left: none;
      justify-content: center;
      align-items: center;
      display: flex;

      &:first-child {
        width: 35%;
        justify-content: start;
      }
      &:last-child {
        width: 25%;
        position: relative;

        > a {
          color: rgb(212, 44, 44);
          font-weight: bold;
          font-family: sans-serif;
          position: absolute;
          right: 8px;
        }
      }
    }
  }

  .-header {
    background: #eeeeee;
    border-top: 1px solid #e5e5e5;

    .-span {
      border-right-color: white;
      &:last-child {
        border-right-color: #e5e5e5;
      }
    }
  }

  .-price {
    &._up {
      background-color: rgb(252, 193, 198);
      color: rgb(209, 50, 50);
    }
    &._down {
      background-color: rgb(184, 240, 192);
      color: rgb(50, 209, 50);
    }
  }

  .-more {
    border-radius: 44px;
    background-color: #eeeeee;
    height: 32px;
    width: 76px;
    outline: 0;
    border: none;
    padding: 0;
    font-size: 14px;
    margin-top: 12px;
    margin-left: -38px;
    left: 50%;
    position: relative;

    &:active {
      opacity: 0.5;
    }
  }
}
</style>